function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import { onLoad, onResize, onScroll } from './_wdh';
/**
 * @module wdh
 */

var WDHComponent = /*#__PURE__*/function () {
  /**
     *  Base class for all WDH components
     *
     *  @param {string} className - Name of the class for the component
     */
  function WDHComponent(className) {
    _classCallCheck(this, WDHComponent);

    /**
     * @private
     * @type {string}
     */
    this.className = className;
    /**
     * @private
     * @type {WDHVariation[]}
     */

    this.variations = [];
    /**
     * @private
     * @type {Node[]}
     */

    this.components = [];
  }
  /**
     * Executes the class behavior and the support methods
     */


  _createClass(WDHComponent, [{
    key: "run",
    value: function run() {
      var _this = this;

      onLoad(function () {
        var componentSelector = _this.className.startsWith('#') || _this.className.startsWith('.') ? _this.className : ".".concat(_this.className);
        _this.components = _this.getNodesFromSelector(componentSelector);

        _this.components.forEach(function (component) {
          // Execute the javascript logic for the component
          try {
            _this.init(component);
          } catch (error) {
            console.log('Component init failed', _this.getClassName(), error);
          } // Loop through registered style variations and execute their init method


          _this.variations.forEach(function (variation) {
            var className = variation.className;

            if (component.classList.contains(className)) {
              try {
                variation.init(component);
              } catch (error) {
                console.log('Variation init failed', className, error);
              }
            }
          });
        });

        onResize(function () {
          _this.components.forEach(function (component) {
            // Execute the javascript logic for the component
            try {
              _this.resize(component);
            } catch (error) {
              console.log('Component resize failed', _this.getClassName(), error);
            }

            _this.variations.forEach(function (variation) {
              var className = variation.className;

              if (component.classList.contains(className)) {
                try {
                  variation.resize(component);
                } catch (error) {
                  console.log('Variation resize failed', className, error);
                }
              }
            });
          });
        });
        onScroll(function (scrollTop) {
          _this.components.forEach(function (component) {
            // Execute the javascript logic for the component
            try {
              _this.scroll(component, scrollTop);
            } catch (error) {
              console.log('Component scroll failed', _this.getClassName(), error);
            }

            _this.variations.forEach(function (variation) {
              var className = variation.className;

              if (component.classList.contains(className)) {
                try {
                  variation.scroll(component, scrollTop);
                } catch (error) {
                  console.log('Variation scroll failed', className, error);
                }
              }
            });
          });
        });
      });
    }
    /**
       * Executes the behavior/logic of the component on load. Override if in component if needed.
       *
       * @param {object} component - JS object of the component
       */

  }, {
    key: "init",
    value: function init(component) {
      /* eslint-disable-line */
      // Only implement if the component has some logic.
    }
  }, {
    key: "resize",
    value: function resize(component) {
      /* eslint-disable-line */
    }
  }, {
    key: "scroll",
    value: function scroll(component, scrollTop) {
      /* eslint-disable-line */
    }
    /**
       * Registers a variation of the component to be executed
       *
       * @param {WDHVariation} variation - Component variation to be registered
       */

  }, {
    key: "registerVariation",
    value: function registerVariation(variation) {
      this.variations.push(variation);
    }
    /**
     * Returns an array of nodes matching the cssSelector. If parentElement only children of parentElement are returned
     * @param {String} cssSelector
     * @param {Node} [parentElement]
     * @returns [Node]
     */

  }, {
    key: "getNodesFromSelector",
    value: function getNodesFromSelector(cssSelector, parentElement) {
      var baseElement = parentElement || document;
      return Array.from(baseElement.querySelectorAll(cssSelector));
    }
    /**
     * Returns the components unique css class name
     * @returns {string}
     */

  }, {
    key: "getClassName",
    value: function getClassName() {
      return this.className;
    }
    /**
     * Returns the set of html components on page matching the components unique css class name
     * @returns {Node[]}
     */

  }, {
    key: "getComponents",
    value: function getComponents() {
      return this.components;
    }
    /**
     * Returns the set of registered variations for the component
     * @returns {WDHVariation[]}
     */

  }, {
    key: "getVariations",
    value: function getVariations() {
      return this.variations;
    }
  }]);

  return WDHComponent;
}();

export default WDHComponent;